import VerticalNavigation from "./VerticalNavigation";

export default VerticalNavigation;
